import React, { useEffect, useState } from "react";
import toastr from "toastr";
import { Row, Col, Button, OverlayTrigger, Tooltip, Card, Modal } from "react-bootstrap";
import { FiPlusCircle, FiEdit3, FiEye } from "react-icons/fi";
import { FaRegTrashAlt } from "react-icons/fa";
import Srcollbar from "react-perfect-scrollbar";
import TableExport from "app/views/custom/components/Export/TableExport";
import ApproveReject from "app/views/custom/components/ApproveReject/ApproveReject";
import { CommmonService } from "app/_services/CommonService/CommonService";
import { Validation } from "app/_helpers/validation/Validation";
import { confirmAlert } from "react-confirm-alert";
import LogHistory from "app/views/custom/components/Logs/LogHistory";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import {
  getAllSites,
  createSite,
  updateSite,
  deleteSite,
} from "app/_services/ehs/ehsSiteServices";
import LeftMenu from "../LeftMenu";
import { CountryService } from "app/_services/ConfigService/CountryService/CountryService";
import { StateService } from "app/_services/ConfigService/StateService/StateService";
import SimpleSelect from "app/Components/SearchableSelect/SimpleSelect";
import paginationFactory from "react-bootstrap-table2-paginator";

const { SearchBar } = Search;

export const siteTypeObj = {
  1: "Head Office(HO)",
  2: "Regional Office(s) (RO)",
  3: "Mines Level",
};

export const siteTypeList = [
  { name: "Head Office(HO)", value: 1 },
  { name: "Regional Office(s) (RO)", value: 2 },
  { name: "Mines Level", value: 3 },
];

export const SITE_STATUS_LIST = [
  { name: "Active", value: "active" },
  { name: "In-Active", value: "inActive" },
];

const initialForm = {
  id: "",
  name: "",
  siteType: "",
  mineCode: "",
  siteId: "",
  stateId: "",
  countryId: "",
  address1: "",
  address2: "",
  city: "",
  pincode: "",
  state: null,
  country: null,
  siteIdCode: "",
  activeStatus: "",
};

const Sites = () => {
  const [showManageModal, setShowManageModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [form, setForm] = useState({ ...initialForm });
  const [errorForm, setErrorForm] = useState({ ...initialForm });
  const [sites, setSites] = useState([]);
  const [states, setStates] = useState([]);
  const [countries, setCountries] = useState([]);

  const onChange = ({ target: { name, type, value, checked } }) => {
    setForm((prevForm) => ({
      ...prevForm,
      stateId: name === "countryId" ? "" : prevForm.stateId,
      parentSiteId: name === "siteType" ? "" : prevForm.parentSiteId,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const onSubmit = CommmonService.debounce(async () => {
    const errorObj = Validation(form, rules);

    let mergedErrorObj = { ...errorObj };

    console.log("mergedErrorObj", mergedErrorObj);

    for (const key in mergedErrorObj)
      if (mergedErrorObj[key]) return setErrorForm(mergedErrorObj);
    // if (sites.find((permit) => +permit.workAreaId === +form.workAreaId && form.id !== permit.id))
    //     return setErrorForm({ ...errorObj, workAreaId: "Permit for this Area already exists!" });
    setErrorForm({ ...initialForm });

    const response = !form.id ? await createSite(form) : await updateSite(form.id, form);

    if (!response?.status) return toastr.error(response?.message);

    form.state = states.find((area) => area.id === +form.stateId);

    // if (!form.id) {
    //   sites.push({
    //     ...form,
    //     id: response.data.id,
    //     status: 0,
    //   });
    // } else {
    //   const index = sites.findIndex((cmp) => cmp.id === +form.id);
    //   sites[index] = { ...sites[index], ...form };
    // }
    toastr.success(response.message || "Success.");
    // setSites(JSON.parse(JSON.stringify(sites)));
    getAllSitesList();
    setShowManageModal(false);
  }, 1000);

  const editSite = async (data) => {
    setForm({ ...data, countryId: data.state?.countryMasterId });

    setShowManageModal(true);
  };

  const viewSite = async (data) => {
    setForm({ ...data });

    setShowViewModal(true);
  };

  const deleteSiteById = async (id, index) => {
    confirmAlert({
      title: "Delete Site.",
      message: "Do you want to proceed?",
      buttons: [
        {
          label: "Yes",
          onClick: async () => {
            const response = await deleteSite(id);

            if (!response?.status) return toastr.error(response?.message);

            sites.splice(index, 1);

            setSites([...sites]);

            toastr.success(response.message || "Success.");
          },
        },
        {
          label: "No",
          onClick: () => {},
        },
      ],
    });
  };

  const columns = [
    {
      dataField: "sid",
      text: "S.No.",
      sort: true,
    },
    {
      dataField: "siteTypeName",
      text: "Type",
      sort: true,
    },
    {
      dataField: "state.country_master.name",
      text: "Country",
      sort: true,
    },
    {
      dataField: "state.name",
      text: "State",
      sort: true,
    },
    {
      dataField: "name",
      text: "Location Name",
      sort: true,
    },
    {
      dataField: "parentSite.name",
      text: "Regional Office",
      sort: true,
    },

    {
      dataField: "siteId",
      text: "Location ID",
      sort: true,
    },
    {
      dataField: "create",
      text: "Action",
      formatter: (rowContent, row) => {
        return (
          <div className="actionIconsGroup">
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip id="tooltip-top">View</Tooltip>}
            >
              <span className="text-cyanBlue icons pointer" onClick={() => viewSite(row)}>
                <FiEye />
              </span>
            </OverlayTrigger>
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip id="tooltip-top">Edit</Tooltip>}
            >
              <span className="icons text-cyanBlue pointer" onClick={() => editSite(row)}>
                <FiEdit3 />
              </span>
            </OverlayTrigger>
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip id="tooltip-top">Delete</Tooltip>}
            >
              <span
                onClick={(e) => deleteSiteById(row.id, row.sid - 1)}
                className="icons text-danger pointer"
              >
                <FaRegTrashAlt />
              </span>
            </OverlayTrigger>
            <ApproveReject
              rowId={row.id}
              tableName={"ehsSite"}
              setData={(status) => {
                sites[row.sid - 1].status = status;
                setSites(JSON.parse(JSON.stringify(sites)));
              }}
              status={row.status}
            />
          </div>
        );
      },
    },
  ];

  const paginationOptions = {
    // custom: true,
    paginationSize: 5,
    pageStartIndex: 1,
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    totalSize: Array.isArray(sites) ? sites.length : 0,
  };

  useEffect(() => {
    CountryService.getCountryAll().then((response) => {
      if (!response?.data) return;

      setCountries(
        response.data.countryMaster.filter((country) => +country.status === 1)
      );
    });

    StateService.getStateAll().then((response) => {
      if (!response?.data) return;

      setStates(response.data.stateMaster.filter((state) => +state.status === 1));
    });

    getAllSites().then((response) => {
      if (!response?.data) return;

      setSites(
        response.data.map((site, index) => ({
          ...site,
          sid: index + 1,
          siteTypeName: siteTypeObj[site?.siteType],
          parentSiteTypeName: siteTypeObj[site?.parentSite?.siteType],
        }))
      );
    });
  }, []);

  const getAllSitesList = () => {
    getAllSites().then((response) => {
      if (!response?.data) return;

      setSites(
        response.data.map((site, index) => ({
          ...site,
          sid: index + 1,
          siteTypeName: siteTypeObj[site?.siteType],
          parentSiteTypeName: siteTypeObj[site?.parentSite?.siteType],
        }))
      );
    });
  };

  useEffect(() => {
    if (showManageModal || showViewModal) return;

    setForm({ ...initialForm });
  }, [showManageModal, showViewModal]);

  console.log("form", form);

  return (
    <div className="healthSafetyEnvironmentWrapper">
      <LeftMenu active={5} />
      <div className="p-4 mb-4 pt-0 mt-4">
        <Card className="compliance-name-table card">
          <Card.Body style={{ borderBottom: "2px solid #f5f5f5" }}>
            <Card.Title>
              <span className="pointer">Locations</span>
            </Card.Title>
          </Card.Body>
          <div className="p-4 pb-0">
            {/* <Srcollbar className="trainingManagementFixedHeight "> */}
            <div className="table-responsive material-master-table">
              <ToolkitProvider
                striped
                keyField="id"
                data={sites.map((p, i) => ({ ...p, sid: i + 1 }))}
                columns={columns}
                search
              >
                {(props) => (
                  <>
                    <div className="d-flex align-items-center justify-content-between pb-3">
                      <SearchBar {...props.searchProps} className="mb-0" />
                      <div className="btn-toolbar">
                        <OverlayTrigger
                          placement="top"
                          overlay={<Tooltip id="tooltip-top">Add Location</Tooltip>}
                        >
                          <span
                            className="icons btn-icon font-20 text-cyanBlue pointer"
                            onClick={() => {
                              setShowManageModal(true);
                            }}
                          >
                            <FiPlusCircle />
                          </span>
                        </OverlayTrigger>
                        <TableExport
                          tableName={"CompleteOwnerPaymentHistory"}
                          dataColumn={columns}
                          hideExportWord={true}
                          renderData={sites.map((p, i) => ({
                            ...p,
                            sid: i + 1,
                          }))}
                          searchText={props.searchProps.searchText}
                        ></TableExport>
                      </div>
                    </div>
                    <div>
                      <BootstrapTable
                        {...props.baseProps}
                        bootstrap4
                        noDataIndication={"Table is empty"}
                        pagination={paginationFactory(paginationOptions)}
                      />
                    </div>
                  </>
                )}
              </ToolkitProvider>
            </div>
            {/* </Srcollbar> */}
          </div>

          <Modal
            size="lg"
            show={showViewModal}
            className="modal-listtraining-course"
            onHide={() => setShowViewModal(false)}
          >
            {/* console.log('data is ',form); */}
            <div className="card" style={{ overflow: "visible" }}>
              <div className="card-body">
                <div className="simple-card-title">
                  <h3 className="text-capitalize mb-1">View Location</h3>
                </div>
                <Row className="mb-3">
                  <Col md="12">
                    <div className="form-group d-flex">
                      <label className="pr-2">Type : </label>
                      <span>{siteTypeObj[form?.siteType]}</span>
                    </div>
                  </Col>
                  {/* {console.log("parentsite is ",form.parentSite)} */}
                  {form.parentSite?.name && (
                    <Col md="12">
                      <div className="form-group d-flex">
                        <label className="pr-2">Regional Office : </label>
                        <span>{form.parentSite?.name}</span>
                      </div>
                    </Col>
                  )}
                  <Col md="12">
                    <div className="form-group d-flex">
                      <label className="pr-2">Country : </label>
                      <span>{form.state?.country_master?.name}</span>
                    </div>
                  </Col>
                  <Col md="12">
                    <div className="form-group d-flex">
                      <label className="pr-2">State : </label>
                      <span>{form.state?.name}</span>
                    </div>
                  </Col>
                  <Col md="12">
                    <div className="form-group d-flex">
                      <label className="pr-2">Location Name : </label>
                      <span>{form.name}</span>
                    </div>
                  </Col>
                  <Col md="12">
                    <div className="form-group d-flex">
                      <label className="pr-2">Location ID : </label>
                      <span>{form.siteId}</span>
                    </div>
                  </Col>
                  {form.parentSite?.name && (
                    <Col md="12">
                      <div className="form-group d-flex">
                        <label className="pr-2">Mine Code (MOL) : </label>
                        <span>{form.mineCode}</span>
                      </div>
                    </Col>
                  )}
                  <Col md="12">
                    <div className="form-group d-flex">
                      <label className="pr-2">Address 1 : </label>
                      <span>{form.address1}</span>
                    </div>
                  </Col>
                  <Col md="12">
                    <div className="form-group d-flex">
                      <label className="pr-2">Address 2 : </label>
                      <span>{form.address2}</span>
                    </div>
                  </Col>
                  <Col md="12">
                    <div className="form-group d-flex">
                      <label className="pr-2">City : </label>
                      <span>{form.city}</span>
                    </div>
                  </Col>
                  <Col md="12">
                    <div className="form-group d-flex">
                      <label className="pr-2">Pin Code : </label>
                      <span>{form.pincode}</span>
                    </div>
                  </Col>

                  <Col lg="12">
                    <div className="form-group d-flex">
                      <label className="pr-2">LocationId (2 Digit) : </label>
                      <span>{form.siteIdCode}</span>
                    </div>
                  </Col>

                  <Col lg="12">
                    <div className="form-group d-flex">
                      <label className="pr-2">Status : </label>
                      <span>
                        {
                          SITE_STATUS_LIST.find((d) => d.value === form.activeStatus)
                            ?.name
                        }
                      </span>
                    </div>
                  </Col>
                </Row>
                <div>
                  <LogHistory subModulename="ehsSite" refrenceId={form.id} />
                </div>
                <div className="mt-2 text-center">
                  <Button
                    onClick={() => {
                      setShowViewModal(false);
                    }}
                    className="btn btn-secondary mr-2"
                  >
                    Close
                  </Button>
                </div>
              </div>
            </div>
          </Modal>

          <Modal
            size={"md"}
            show={showManageModal}
            className="modal-listtraining-course"
            onHide={() => setShowManageModal(false)}
          >
            <div className="card overflow-visible">
              <div className="card-body">
                <div className="simple-card-title">
                  <h3 className="text-capitalize mb-1">
                    {form.id ? "Edit" : "Add"} Location
                  </h3>
                </div>
                <Row>
                  <Col lg="12">
                    <div className="form-group mb-3">
                      <label>Type</label>

                      <SimpleSelect
                        className="form-control"
                        name="siteType"
                        onChange={onChange}
                        value={form.siteType}
                        disabled={form.id}
                        id="value"
                        label="name"
                        options={siteTypeList}
                        init="Select"
                        menuPortalTarget={null}
                      ></SimpleSelect>

                      <span className="text-danger small">{errorForm.type}</span>
                    </div>
                  </Col>
                  <Col lg="12">
                    <div className="form-group mb-3">
                      <label>Location ID</label>
                      <input
                        name="siteId"
                        value={form.siteId}
                        onChange={onChange}
                        className="form-control"
                      />
                      <span className="text-danger small">{errorForm.siteId}</span>
                    </div>
                  </Col>
                  <Col lg="12">
                    <div className="form-group mb-3">
                      <label>Location Name</label>
                      <input
                        name="name"
                        value={form.name}
                        onChange={onChange}
                        className="form-control"
                      />
                      <span className="text-danger small">{errorForm.name}</span>
                    </div>
                  </Col>
                  <Col lg="12">
                    <div className="form-group mb-3">
                      <label>LocationId (2 Digit)</label>
                      <input
                        name="siteIdCode"
                        value={form?.siteIdCode}
                        onChange={onChange}
                        className="form-control"
                      />
                      <span className="text-danger small">{errorForm?.siteIdCode}</span>
                    </div>
                  </Col>
                  {form.siteType === 3 && (
                    <Col lg="12">
                      <div className="form-group mb-3">
                        <label>Mine Code (MOL)</label>
                        <input
                          name="mineCode"
                          value={form.mineCode}
                          onChange={onChange}
                          className="form-control"
                        />
                        <span className="text-danger small">{errorForm.mineCode}</span>
                      </div>
                    </Col>
                  )}
                  {form.siteType === 3 && (
                    <Col lg="12">
                      <div className="form-group mb-3">
                        <label>Regional Office</label>

                        <SimpleSelect
                          className="form-control"
                          name="parentSiteId"
                          onChange={onChange}
                          value={form.parentSiteId}
                          disabled={form.id}
                          id="id"
                          label="name"
                          options={sites.filter((d) => d.siteType === 2)}
                          init="Select"
                          menuPortalTarget={null}
                        ></SimpleSelect>

                        <span className="text-danger small">{errorForm.type}</span>
                      </div>
                    </Col>
                  )}

                  <Col lg="12">
                    <div className="form-group mb-3">
                      <label>Address 1</label>
                      <input
                        name="address1"
                        value={form.address1}
                        onChange={onChange}
                        className="form-control"
                      />
                      <span className="text-danger small">{errorForm.address1}</span>
                    </div>
                  </Col>
                  <Col lg="12">
                    <div className="form-group mb-3">
                      <label>Address 2</label>
                      <input
                        name="address2"
                        value={form.address2}
                        onChange={onChange}
                        className="form-control"
                      />
                      <span className="text-danger small">{errorForm.address2}</span>
                    </div>
                  </Col>
                  <Col lg="12">
                    <div className="form-group mb-3">
                      <label>City</label>
                      <input
                        name="city"
                        value={form.city}
                        onChange={onChange}
                        className="form-control"
                      />
                      <span className="text-danger small">{errorForm.city}</span>
                    </div>
                  </Col>

                  <Col lg="12">
                    <div className="form-group mb-3">
                      <label>Country</label>

                      <SimpleSelect
                        className="form-control"
                        name="countryId"
                        onChange={onChange}
                        value={form.countryId}
                        // disabled={form.id && form.stateId}
                        id="id"
                        label="name"
                        options={countries}
                        init="Select"
                        menuPortalTarget={null}
                      ></SimpleSelect>

                      <span className="text-danger small">{errorForm.countryId}</span>
                    </div>
                  </Col>
                  <Col lg="12">
                    <div className="form-group mb-3">
                      <label>State</label>
                      <select
                        className="form-control"
                        name="stateId"
                        onChange={onChange}
                        value={form.stateId}
                        // disabled={form.id && form.stateId}
                      >
                        <option value="">Select</option>
                        {states
                          .filter((state) => +state.countryMasterId === +form.countryId)
                          .map((state, index) => (
                            <option key={index} value={state.id}>
                              {state.name}
                            </option>
                          ))}
                      </select>
                      <span className="text-danger small">{errorForm.stateId}</span>
                    </div>
                  </Col>
                  <Col lg="12">
                    <div className="form-group mb-3">
                      <label>Pin Code</label>
                      <input
                        name="pincode"
                        value={form.pincode}
                        onChange={onChange}
                        className="form-control"
                      />
                      <span className="text-danger small">{errorForm.pincode}</span>
                    </div>
                  </Col>
                  <Col lg="12">
                    <div className="form-group mb-3">
                      <label>Status</label>

                      <SimpleSelect
                        className="form-control"
                        name="activeStatus"
                        onChange={onChange}
                        value={form.activeStatus}
                        // disabled={form.id}
                        id="value"
                        label="name"
                        options={SITE_STATUS_LIST}
                        init="Select"
                        menuPortalTarget={null}
                      ></SimpleSelect>

                      <span className="text-danger small">{errorForm.activeStatus}</span>
                    </div>
                  </Col>
                </Row>
                <div className="mt-2 text-center">
                  <Button
                    onClick={() => {
                      setShowManageModal(false);
                    }}
                    className="btn btn-secondary mr-2"
                  >
                    Close
                  </Button>
                  <Button
                    onClick={onSubmit}
                    type="submit"
                    variant="primary"
                    className="m-1 text-capitalize"
                  >
                    Save
                  </Button>
                </div>
              </div>
            </div>
          </Modal>
        </Card>
      </div>
    </div>
  );
};

const rules = [
  {
    field_name: "countryId",
    label: "Country",
    type: "string",
    isRequired: true,
  },
  {
    field_name: "stateId",
    label: "State",
    type: "string",
    isRequired: true,
  },
  {
    field_name: "name",
    label: "Name",
    type: "string",
    isRequired: true,
  },
  {
    field_name: "siteId",
    label: "Site ID",
    type: "string",
    isRequired: true,
  },
  {
    field_name: "siteIdCode",
    label: "Site ID Code",
    type: "string",
    isRequired: true,
    maxLength: 2,
  },
  {
    field_name: "activeStatus",
    label: "Status",
    type: "string",
    isRequired: true,
  },
];

export default Sites;
